import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';
import { IToDoRequest, IToDoResponse } from '../models/todos.model';

export const loadTodos = createAction('[Todo] Load Todos', props<{ request: IToDoRequest }>());

export const loadTodosSuccess = createAction('[Todo] Load Todos Success', props<{ response: IToDoResponse }>());

export const loadTodosFailure = createAction('[Todo] Load Todos Failure', props<{ error: IGenericError<ErrorResponse> }>());

export const clearToDos = createAction('[Todo] Clear Todos');
